import React from "react";
import "./footer.scss"

export default class Footer extends React.Component{
  render() {
    return(
      <footer className="footer">GoldRiver 2020</footer>
    )
  }
}